export const isAdmin = membership => membership.accountType === 'ADMIN'
export const isUser = membership => membership.accountType === 'USER'
export const isWriter = membership => membership.accountType === 'WRITER'
